export default __webpack_public_path__ + "5710eb068c6a0a1ba8fedc8aad823a3e.png";